import React from 'react';
import styled from 'styled-components';
import { search } from '../../images';
import { connect } from 'react-redux';
import { setSearch } from '../../reducers/search/actions';
import { navigate } from '../../services';
import { device } from '../../helpers';
import trimStart from 'lodash/trimStart';
import { RouteLocation } from '../../lib/routing/Navigator';
import { AppState } from '../../store';

const Container = styled.div<State>`
    cursor: pointer;
    display: flex;
    flex-direction: row;
    position: relative;
    align-items: center;
    bottom: -2px;
    margin: 0 17px 0 26px;
    padding: 0 19px;
    width: 100%;
    height: 38px;
    font-weight: 500;
    background: ${(p) => (p.focused ? '#fff' : '#ebebeb')};
    border-radius: 24px;
    border: 1px solid #ebebeb;
    transition: all 0.2s ease-in-out;

    &:hover {
        border-color: #d1d1d1;
    }

    @media ${device.phone} {
        margin: 0;
    }
`;

const Image = styled.img`
    width: 18px;
    height: 18px;
    margin-left: 15px;
`;

const Input = styled.input<State>`
    border: 0;
    white-space: nowrap;
    font-size: 15px;
    font-weight: 500;
    font-family: urdu;
    height: 38px;
    width: 100%;
    line-height: 26px;
    color: ${(p) => (p.focused ? '#111' : '#838383')};
    background-color: transparent;

    &:focus {
        border: 0;
        outline: 0;
    }
`;

const mapStateToProps = (state: AppState) => ({
    // @ts-ignore
    search: state.search.get('text') as string,
});
const mapDispatch = { setSearch };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatch;
type OwnProps = {
    location: RouteLocation;
};
type Props = StateProps & DispatchProps & OwnProps;
type State = {
    focused: boolean;
};
class HeaderSearch extends React.Component<Props, State> {
    state = {
        focused: false,
    };

    onFocus = () => this.setState({ focused: true });
    onBlur = () => this.setState({ focused: false });
    onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const search = trimStart(evt.target.value);
        this.props.setSearch(search);

        if (search) {
            navigate.to(`/app/s/${search}`);

            const { gtag } = window;
            gtag('event', 'search', {
                event_category: 'header',
                event_label: search,
            });
        } else {
            navigate.to('/app/');
        }
    };

    render() {
        return (
            <Container focused={this.state.focused}>
                <Image src={search} />
                <Input
                    placeholder="تلاش کرؤ"
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                    onChange={this.onChange}
                    value={this.props.search}
                    focused={this.state.focused}
                />
            </Container>
        );
    }
}

export default connect(mapStateToProps, mapDispatch)(HeaderSearch);
